import styled from 'styled-components';

// Fills the viewport so the footer sits at the bottom of short screens
export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(var(--vh, 1svh) * 100);
`;

// A block box, so each screen lays out exactly as it did without the wrapper
export const Main = styled.div`
  flex: 1 0 auto;
`;
